import { Component } from '@angular/core';

@Component({
    template: '<router-outlet></router-outlet>'
})

export class FirmwareComponent {
}


// WEBPACK FOOTER //
// ./app/admin/firmware/admin.firmware.component.ts